export default "__VITE_ASSET__tVFogExc__"